import { PlusOutlined } from '@ant-design/icons';
import { DOCTOR_HOW_IT_WORKS_PAGES } from '@medicusunion/front-utils';
import { Button } from 'antd';
import { DATE_FORMAT_REVERSE } from 'constants/dates';
import dayjs from 'dayjs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams
} from 'react-router-dom';

import { HowItWorksLink } from 'components/shared';
import { PageWrapper } from 'components/ui';
import Filters from './components/Filters';
import { StyledSegmented } from './styled';

enum ReportTypes {
  personal = 'personal',
  medicus = 'medicus'
}

const Reports: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const type = pathname.split('/')[2];

  const [searchParams, setSearchParams] = useSearchParams();

  const howItWorksButton = (
    <HowItWorksLink
      key="how-it-works"
      type={DOCTOR_HOW_IT_WORKS_PAGES.REPORT.key}
      title={t('common.how_it_works')}
    />
  );

  return (
    <PageWrapper
      title={t(`reports.page_title`)}
      color="white"
      extra={
        type === ReportTypes.personal
          ? [
              howItWorksButton,
              <div key="add-button">
                <Link to="/report/details">
                  <Button type="primary" size="large">
                    <PlusOutlined /> {t('reports.add_new_report')}
                  </Button>
                </Link>
              </div>
            ]
          : [howItWorksButton]
      }
    >
      <StyledSegmented
        value={type}
        onChange={value => navigate(`/report/${value}`)}
        size="large"
        options={[
          {
            label: (
              <div style={{ display: 'inline-block' }}>
                {t(`reports.medicus_reports`)}
              </div>
            ),
            value: ReportTypes.medicus
          },
          {
            label: <div>{t(`reports.personal_reports`)}</div>,
            value: ReportTypes.personal
          }
        ]}
      />
      <Filters
        onSubmit={values => {
          searchParams.set('page', '0');

          if (values.status) {
            searchParams.set('status', '0');
          } else {
            searchParams.delete('status');
          }

          if (values.name) {
            searchParams.set('name', values.name);
          } else {
            searchParams.delete('name');
          }

          if (values.date?.[0]) {
            searchParams.set(
              'startDate',
              values.date[0]?.format(DATE_FORMAT_REVERSE)
            );
          } else {
            searchParams.delete('startDate');
          }

          if (values.date?.[1]) {
            searchParams.set(
              'endDate',
              values.date[1].format(DATE_FORMAT_REVERSE)
            );
          } else {
            searchParams.delete('endDate');
          }

          setSearchParams(searchParams);
        }}
        values={{
          name: searchParams.get('name') || undefined,
          date:
            searchParams.get('startDate') && searchParams.get('endDate')
              ? [
                  dayjs(searchParams.get('startDate')),
                  dayjs(searchParams.get('endDate'))
                ]
              : undefined,
          status: searchParams.get('status') || undefined
        }}
      />
      <Outlet />
    </PageWrapper>
  );
};

export default Reports;
